<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card>
          <ValidationObserver ref="form" v-slot="{ passes }">
            <v-form
              @submit.prevent="passes(filterData)"
              class="report-filter mb-5"
            >
              <v-card>
                <v-card-title>{{ $t("language.filter") }}</v-card-title>
                <v-card-text>
                  <v-container grid-list-xl>
                    <v-layout wrap>
                      <slot name="filter"></slot>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    dense
                    color="general"
                    class="mr-2"
                    light
                    type="submit"
                    >{{ $t("language.filter") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-form>
          </ValidationObserver>
          <v-card v-if="showreport">
            <v-card-title>
              <v-spacer />
              <v-icon @click="print" class="mr-2">print</v-icon>
              <v-icon @click="exportExcel">vertical_align_bottom</v-icon>
            </v-card-title>
            <v-card-text>
              <div id="print" class="bootstrap">
                <table class="w-100">
                  <tr class="v-hide">
                    <td>
                      <table class="w-100">
                        <tr>
                          <td width="100" rowspan="2">
                            <img
                              style="max-width: 100px; max-height: 75px"
                              :src="logo"
                            />
                          </td>
                          <td align="center">
                            <h4>{{ $store.getters.company.name }}</h4>
                          </td>
                        </tr>
                        <tr>
                          <td align="center">
                            <div>{{ $store.getters.company.address }}</div>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr class="v-hide">
                    <td><br /></td>
                  </tr>
                  <tr class="v-hide">
                    <td>
                      <slot name="printheader"></slot>
                    </td>
                  </tr>
                  <tr class="v-hide">
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      <slot name="table" v-bind:data="data"></slot>
                    </td>
                  </tr>
                  <tr class="v-hide">
                    <td><br /><br /><br /></td>
                  </tr>
                  <tr class="v-hide">
                    <td>
                      <table class="w-100">
                        <tr>
                          <td align="center">.............................</td>
                          <td></td>
                          <td align="center">.............................</td>
                          <td></td>
                          <td align="center">.............................</td>
                        </tr>
                        <tr>
                          <td align="center">{{ $t("language.preparedby") }}</td>
                          <td></td>
                          <td align="center">{{ $t("language.checkedby") }}</td>
                          <td></td>
                          <td align="center">{{ $t("language.approvedby") }}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import commonservice from "../../../shared/common.service";
export default {
  name: "reportview",
  props: ["title", "url", "filter", "landscape"],
  data() {
    return {
      loading: false,
      showreport: false,
      data: null,
    };
  },
  computed: {
    logo() {
      return (
        process.env.VUE_APP_API_URL.replace("/api/", "") +
        this.$store.getters.company.logo
      );
    },
  },
  methods: {
    filterData() {
      if (this.loading) return;
      let url =
        this.url + "?" + commonservice.convertToQueryString(this.filter);

      this.loading = true;
      this.showreport = false;
      axios
        .get(url)
        .then((response) => {
          this.loading = false;
          this.showreport = true;
          this.data = response.data;

          this.$emit("filtered", this.data);
          // if (response.data.length > 0) {
          //   this.showreport = true;
          //   this.data = response.data;
          // } else {
          //   this.$store.dispatch(
          //     "showErrorMessage",
          //     this.$t("language.nodatafound")
          //   );
          // }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    print() {
      const options = {
        styles: [
          "http://admin.ehajir.com/css/bootstrap.min.css",
          "http://admin.ehajir.com/css/print.css?v7",
        ],
      };
      if (this.landscape)
        options.styles.push("http://admin.ehajir.com/css/landscape.css");
      this.$htmlToPaper("print", options);
    },
    exportExcel() {
      var table = document.getElementById("print");
      var html = table.outerHTML.replace(
        new RegExp("<table", "g"),
        '<table border="1" width="100%"'
      );
      html = html.replace(
        new RegExp('<table border="1" width="100%" class="w-100">', "g"),
        '<table width="100%">'
      );
      html = html.replace(
        new RegExp('<table border="1" width="100%" class="printheader">', "g"),
        '<table width="100%">'
      );
      var url = "data:application/vnd.ms-excel," + escape(html);
      var elem = document.createElement("a");
      // Set your html table into url
      elem.setAttribute("href", url);
      elem.setAttribute("download", escape(this.title) + ".xls");
      elem.click();
      return false;
    },
  },
};
</script>
